import { render } from "./HelloView.vue?vue&type=template&id=7fc5b87d"
import script from "./HelloView.vue?vue&type=script&lang=js"
export * from "./HelloView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__